/**
 * Service for managing SKUs
 */export class SkusService{constructor(apiService){this.apiService=apiService;}/**
   * Get a list of SKUs with pagination
   */async getSkus(params){const queryParams={...params,...(params.searchTerm&&params.searchTerm.trim().length>=3?{searchTerm:params.searchTerm.trim()}:{})};return this.apiService.get('/api/skus',queryParams);}/**
   * Get a specific SKU by ID
   */async getSku(skuId){return this.apiService.get(`/api/skus/${skuId}`);}/**
   * Create a new SKU
   */async createSku(sku){return this.apiService.post('/api/skus',sku);}/**
   * Update an existing SKU
   */async updateSku(skuId,sku){return this.apiService.put(`/api/skus/${skuId}`,sku);}/**
   * Delete a SKU
   */async deleteSku(skuId){return this.apiService.delete(`/api/skus/${skuId}`);}}